import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http.service';
import { Observable, Subject } from 'rxjs';
import { UserConfig } from '@app/pages/rbac/users/user.config';
import { FontSetList, themeList } from '@app/@core/entities/theme-constants';
import { ThemeService } from '@app/@core/services/theme.service';
import { LocalService } from '@app/@core/services/local.service';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  profileImage: Subject<any> = new Subject();
  constructor(
    private httpService: HttpService,
    private themeService: ThemeService,
    private localstorage: LocalService
  ) {
     // This is intentional
  }

  setUserPreference() {
    const user_id = this.localstorage.getItem('id');
    if (user_id) {
      this.getUserPreference(user_id).subscribe((res: any) => {
        if (res.data && res.data?.config) {
          const configArray = JSON.parse(res.data.config);
          this.setTheme(configArray.theme);
          this.setFont(configArray.font);
        }
      });
    }
  }
  setTheme(event) {
    this.localstorage.setItem('SELECTED_THEME', event);
    const selectedTheme = themeList.filter(theme => theme.key === event)[0];
    this.themeService.setActiveTheme(selectedTheme);
    console.log('Selected Theme:', selectedTheme.key);
  }
  setFont(event) {
    this.localstorage.setItem('SELECTED_FONT', event);
    const selectedFont = FontSetList.filter(fontSet => fontSet.key === event)[0];
    this.themeService.setActiveFont(selectedFont);
  }

  getProfile(img: any) {
    this.profileImage.next(img);
  }

  getAllUserList(key?: string): Observable<any> {
    return this.httpService.get(`${UserConfig.EndPoint.User.getAllUserList}/${key}`);
  }
  getAllUserOrgList(orgid: any) {
    return this.httpService.get(UserConfig.EndPoint.User.getAllUserOrgList + orgid);
  }
  getUserPreference(id) {
    return this.httpService.get(UserConfig.EndPoint.User.getUserConfig.replace('{id}', id));
  }
  updateUser(data: any, userid: string) {
    return this.httpService.patch(`${UserConfig.EndPoint.User.getAllUserList}/${userid}/updateUserDetails`, data);
  }
  saveUserPreference(data) {
    return this.httpService.post(UserConfig.EndPoint.User.saveUserConfig, data);
  }
}
